module.exports = __webpack_public_path__ + "static/media/proizvodstvennaya_programma.51da2af3.pdf";